import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_VabeneAddFeature = _resolveComponent("VabeneAddFeature");
    return (_openBlock(), _createBlock(_component_VabeneAddFeature, {
        action: _ctx.action,
        featureID: _ctx.featureID
    }, null, 8, ["action", "featureID"]));
}
